import React from 'react';

import { useAppSelector } from '@/redux/store';

import ProfitDropCard from './ProfitDrop/ProfitDropCard';
import ArenaOfferCard from './ArenaOfferCard';
import BingoEventCard from './BingoEventCard';

const ArenaOffers: React.FC = () => {
  const arenaOffers = useAppSelector((state) => state.shop.arenaOffers);
  const profitDropOffers = useAppSelector(
    (state) => state.shop.profitDropOffers,
  );

  return (
    <div className="flex flex-col gap-[1.5625rem]">
      <BingoEventCard />
      {!!profitDropOffers.length && <ProfitDropCard />}
      {arenaOffers.map((el, index) => (
        <ArenaOfferCard key={index} {...el} />
      ))}
    </div>
  );
};

export default ArenaOffers;
